import { render } from "./SignTemplate.vue?vue&type=template&id=6e9cfcd3&scoped=true"
import script from "./SignTemplate.vue?vue&type=script&lang=js"
export * from "./SignTemplate.vue?vue&type=script&lang=js"

import "./SignTemplate.vue?vue&type=style&index=0&id=6e9cfcd3&lang=css"
import "./SignTemplate.vue?vue&type=style&index=1&id=6e9cfcd3&scoped=true&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9cfcd3"],['__file',"src/components/project/templates/SignTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e9cfcd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e9cfcd3', __exports__)) {
    console.log('reload')
    api.reload('6e9cfcd3', __exports__)
  }
  
  module.hot.accept("./SignTemplate.vue?vue&type=template&id=6e9cfcd3&scoped=true", () => {
    console.log('re-render')
    api.rerender('6e9cfcd3', render)
  })

}


export default __exports__